export default __webpack_public_path__ + "img/spHygEKf.73149a59.svg";